/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type C4CModeEnum = "CASE4CAUSE" | "GRAPEFULCLUB" | "NONE" | "%future added value";
export type CartTogglePCMembershipMutationInput = {
    readonly clientMutationId?: string | null;
};
export type CartTogglePCMembershipMutationVariables = {
    readonly input: CartTogglePCMembershipMutationInput;
};
export type CartTogglePCMembershipMutationResponse = {
    readonly cartTogglePCMembership: ({
        readonly cart: ({
            readonly id: string;
            readonly autoShipEnabled: boolean | null;
            readonly autoShipIntervalUnit: string | null;
            readonly autoShipIntervalCount: number | null;
            readonly c4cMode: C4CModeEnum | null;
            readonly enrollingAsPc: boolean | null;
            readonly totalSavings: number | null;
            readonly promoCodeSavings: number | null;
            readonly pcPotentialSavings: ReadonlyArray<number | null> | null;
            readonly viaQualifiedCartTotal: number | null;
            readonly totalNumberOfItems: number | null;
            readonly subTotalPriceOfItems: number | null;
            readonly subTotalPriceOfItemsWithPromoCodes: number | null;
            readonly promoCodeIsValid: boolean | null;
            readonly eventId: string | null;
            readonly entries: ({
                readonly edges: ReadonlyArray<({
                    readonly node: ({
                        readonly id: string;
                        readonly product: ({
                            readonly id: string;
                            readonly name: string | null;
                            readonly price: number | null;
                            readonly productURLslug: string | null;
                            readonly images: ({
                                readonly id: string;
                                readonly productCatalog: string | null;
                            }) | null;
                            readonly categoryFood: boolean | null;
                            readonly categoryMerch: boolean | null;
                            readonly categoryWine: boolean | null;
                            readonly company: string | null;
                            readonly priceSale: number | null;
                            readonly productId: string | null;
                            readonly inventorySKU: string | null;
                            readonly productPermissions: ({
                                readonly oneCommerce: ({
                                    readonly preferredCustomer: ({
                                        readonly add: boolean | null;
                                    }) | null;
                                }) | null;
                            }) | null;
                            readonly promoCodeDiscount: ({
                                readonly case4Cause: ({
                                    readonly case12PriceUSD: number | null;
                                    readonly case6PriceUSD: number | null;
                                    readonly case6SKU: string | null;
                                    readonly case12SKU: string | null;
                                    readonly donationEligible: boolean | null;
                                }) | null;
                            }) | null;
                        }) | null;
                        readonly quantity: number | null;
                    }) | null;
                }) | null> | null;
            }) | null;
            readonly promoCodes: ReadonlyArray<({
                readonly code: string | null;
                readonly promoDescription: string | null;
                readonly thresholds: ReadonlyArray<({
                    readonly discountAmount: string | null;
                    readonly discountAmountEach: string | null;
                }) | null> | null;
            }) | null> | null;
            readonly promoCodeDiscountedItems: ReadonlyArray<({
                readonly id: string;
                readonly nonDiscountedSkus: ({
                    readonly edges: ReadonlyArray<({
                        readonly node: ({
                            readonly id: string;
                            readonly sku: string | null;
                            readonly discountAmount: number | null;
                            readonly productId: string | null;
                            readonly quantity: number | null;
                            readonly product: ({
                                readonly id: string;
                                readonly productId: string | null;
                                readonly productURLslug: string | null;
                                readonly name: string | null;
                                readonly price: number | null;
                                readonly priceSale: number | null;
                                readonly productPermissions: ({
                                    readonly oneCommerce: ({
                                        readonly preferredCustomer: ({
                                            readonly add: boolean | null;
                                        }) | null;
                                    }) | null;
                                }) | null;
                                readonly promoCodeDiscount: ({
                                    readonly case4Cause: ({
                                        readonly case6PriceUSD: number | null;
                                    }) | null;
                                }) | null;
                                readonly images: ({
                                    readonly id: string;
                                    readonly productCatalog: string | null;
                                    readonly productFront: string | null;
                                    readonly productBack: string | null;
                                }) | null;
                            }) | null;
                        }) | null;
                    }) | null> | null;
                }) | null;
                readonly discountedSkus: ({
                    readonly edges: ReadonlyArray<({
                        readonly node: ({
                            readonly id: string;
                            readonly sku: string | null;
                            readonly discountAmount: number | null;
                            readonly productId: string | null;
                            readonly quantity: number | null;
                            readonly product: ({
                                readonly id: string;
                                readonly productId: string | null;
                                readonly productURLslug: string | null;
                                readonly name: string | null;
                                readonly price: number | null;
                                readonly priceSale: number | null;
                                readonly productPermissions: ({
                                    readonly oneCommerce: ({
                                        readonly preferredCustomer: ({
                                            readonly add: boolean | null;
                                        }) | null;
                                    }) | null;
                                }) | null;
                                readonly promoCodeDiscount: ({
                                    readonly case4Cause: ({
                                        readonly case6PriceUSD: number | null;
                                    }) | null;
                                }) | null;
                                readonly images: ({
                                    readonly id: string;
                                    readonly productCatalog: string | null;
                                    readonly productFront: string | null;
                                    readonly productBack: string | null;
                                }) | null;
                            }) | null;
                        }) | null;
                    }) | null> | null;
                }) | null;
            }) | null> | null;
        }) | null;
    }) | null;
};
export type CartTogglePCMembershipMutation = {
    readonly response: CartTogglePCMembershipMutationResponse;
    readonly variables: CartTogglePCMembershipMutationVariables;
};



/*
mutation CartTogglePCMembershipMutation(
  $input: CartTogglePCMembershipMutationInput!
) {
  cartTogglePCMembership(input: $input) {
    cart {
      id
      autoShipEnabled
      autoShipIntervalUnit
      autoShipIntervalCount
      c4cMode
      enrollingAsPc
      totalSavings
      promoCodeSavings
      pcPotentialSavings
      viaQualifiedCartTotal
      totalNumberOfItems
      subTotalPriceOfItems
      subTotalPriceOfItemsWithPromoCodes
      promoCodeIsValid
      eventId
      entries {
        edges {
          node {
            id
            product {
              id
              name
              price
              productURLslug
              images {
                id
                productCatalog
              }
              categoryFood
              categoryMerch
              categoryWine
              company
              priceSale
              productId
              inventorySKU
              productPermissions {
                oneCommerce {
                  preferredCustomer {
                    add
                  }
                }
              }
              promoCodeDiscount {
                case4Cause {
                  case12PriceUSD
                  case6PriceUSD
                  case6SKU
                  case12SKU
                  donationEligible
                }
              }
            }
            quantity
          }
        }
      }
      promoCodes {
        code
        promoDescription
        thresholds {
          discountAmount
          discountAmountEach
        }
        id
      }
      promoCodeDiscountedItems {
        id
        nonDiscountedSkus {
          edges {
            node {
              id
              sku
              discountAmount
              productId
              quantity
              product {
                id
                productId
                productURLslug
                name
                price
                priceSale
                productPermissions {
                  oneCommerce {
                    preferredCustomer {
                      add
                    }
                  }
                }
                promoCodeDiscount {
                  case4Cause {
                    case6PriceUSD
                  }
                }
                images {
                  id
                  productCatalog
                  productFront
                  productBack
                }
              }
            }
          }
        }
        discountedSkus {
          edges {
            node {
              id
              sku
              discountAmount
              productId
              quantity
              product {
                id
                productId
                productURLslug
                name
                price
                priceSale
                productPermissions {
                  oneCommerce {
                    preferredCustomer {
                      add
                    }
                  }
                }
                promoCodeDiscount {
                  case4Cause {
                    case6PriceUSD
                  }
                }
                images {
                  id
                  productCatalog
                  productFront
                  productBack
                }
              }
            }
          }
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "CartTogglePCMembershipMutationInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "CartTogglePCMembershipMutationInput!"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "viaQualifiedCartTotal",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "autoShipIntervalUnit",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "autoShipIntervalCount",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "c4cMode",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "enrollingAsPc",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "totalSavings",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "promoCodeSavings",
        "args": null,
        "storageKey": null
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "pcPotentialSavings",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "autoShipEnabled",
        "args": null,
        "storageKey": null
    } as any), v12 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "totalNumberOfItems",
        "args": null,
        "storageKey": null
    } as any), v13 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "subTotalPriceOfItems",
        "args": null,
        "storageKey": null
    } as any), v14 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "subTotalPriceOfItemsWithPromoCodes",
        "args": null,
        "storageKey": null
    } as any), v15 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "promoCodeIsValid",
        "args": null,
        "storageKey": null
    } as any), v16 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "eventId",
        "args": null,
        "storageKey": null
    } as any), v17 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "price",
        "args": null,
        "storageKey": null
    } as any), v18 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "productURLslug",
        "args": null,
        "storageKey": null
    } as any), v19 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "productCatalog",
        "args": null,
        "storageKey": null
    } as any), v20 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v21 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "priceSale",
        "args": null,
        "storageKey": null
    } as any), v22 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "productId",
        "args": null,
        "storageKey": null
    } as any), v23 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "productPermissions",
        "storageKey": null,
        "args": null,
        "concreteType": "ProductPermissions",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "oneCommerce",
                "storageKey": null,
                "args": null,
                "concreteType": "AppProductPermissionsAccess",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "preferredCustomer",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ProductPermissionsAccess",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "add",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            }
        ]
    } as any), v24 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "case6PriceUSD",
        "args": null,
        "storageKey": null
    } as any), v25 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "quantity",
        "args": null,
        "storageKey": null
    } as any), v26 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "entries",
        "storageKey": null,
        "args": null,
        "concreteType": "CartEntryV3Connection",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CartEntryV3Edge",
                "plural": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CartEntryV3",
                        "plural": false,
                        "selections": [
                            (v3 /*: any*/),
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "product",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Product",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "categoryWine",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    (v3 /*: any*/),
                                    (v17 /*: any*/),
                                    (v18 /*: any*/),
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "images",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "Images",
                                        "plural": false,
                                        "selections": [
                                            (v3 /*: any*/),
                                            (v19 /*: any*/)
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "categoryFood",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "categoryMerch",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    (v20 /*: any*/),
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "company",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    (v21 /*: any*/),
                                    (v22 /*: any*/),
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "inventorySKU",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    (v23 /*: any*/),
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "promoCodeDiscount",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "PromoCodeDiscount",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "case4Cause",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "Case4Cause",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "case12PriceUSD",
                                                        "args": null,
                                                        "storageKey": null
                                                    },
                                                    (v24 /*: any*/),
                                                    {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "case6SKU",
                                                        "args": null,
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "case12SKU",
                                                        "args": null,
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "donationEligible",
                                                        "args": null,
                                                        "storageKey": null
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            (v25 /*: any*/)
                        ]
                    }
                ]
            }
        ]
    } as any), v27 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "code",
        "args": null,
        "storageKey": null
    } as any), v28 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "promoDescription",
        "args": null,
        "storageKey": null
    } as any), v29 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "discountAmount",
        "args": null,
        "storageKey": null
    } as any), v30 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "thresholds",
        "storageKey": null,
        "args": null,
        "concreteType": "PromoCodeThresholds",
        "plural": true,
        "selections": [
            (v29 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "discountAmountEach",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v31 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "PromoCodeItemDiscountEdge",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PromoCodeItemDiscountTuple",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "sku",
                            "args": null,
                            "storageKey": null
                        },
                        (v29 /*: any*/),
                        (v22 /*: any*/),
                        (v25 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "product",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Product",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/),
                                (v22 /*: any*/),
                                (v18 /*: any*/),
                                (v20 /*: any*/),
                                (v17 /*: any*/),
                                (v21 /*: any*/),
                                (v23 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "promoCodeDiscount",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PromoCodeDiscount",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "case4Cause",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Case4Cause",
                                            "plural": false,
                                            "selections": [
                                                (v24 /*: any*/)
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "images",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Images",
                                    "plural": false,
                                    "selections": [
                                        (v3 /*: any*/),
                                        (v19 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "productFront",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "productBack",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        } as any)
    ], v32 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "promoCodeDiscountedItems",
        "storageKey": null,
        "args": null,
        "concreteType": "PromoCodeDiscountItem",
        "plural": true,
        "selections": [
            (v3 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "nonDiscountedSkus",
                "storageKey": null,
                "args": null,
                "concreteType": "PromoCodeItemDiscountConnection",
                "plural": false,
                "selections": (v31 /*: any*/)
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "discountedSkus",
                "storageKey": null,
                "args": null,
                "concreteType": "PromoCodeItemDiscountConnection",
                "plural": false,
                "selections": (v31 /*: any*/)
            }
        ]
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "CartTogglePCMembershipMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "cartTogglePCMembership",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "CartTogglePCMembershipMutationPayload",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "cart",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Cart",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                (v7 /*: any*/),
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                (v10 /*: any*/),
                                (v11 /*: any*/),
                                (v12 /*: any*/),
                                (v13 /*: any*/),
                                (v14 /*: any*/),
                                (v15 /*: any*/),
                                (v16 /*: any*/),
                                (v26 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "promoCodes",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PromoCode",
                                    "plural": true,
                                    "selections": [
                                        (v27 /*: any*/),
                                        (v28 /*: any*/),
                                        (v30 /*: any*/)
                                    ]
                                },
                                (v32 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "CartTogglePCMembershipMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "cartTogglePCMembership",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "CartTogglePCMembershipMutationPayload",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "cart",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Cart",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                (v7 /*: any*/),
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                (v10 /*: any*/),
                                (v11 /*: any*/),
                                (v12 /*: any*/),
                                (v13 /*: any*/),
                                (v14 /*: any*/),
                                (v15 /*: any*/),
                                (v16 /*: any*/),
                                (v26 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "promoCodes",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PromoCode",
                                    "plural": true,
                                    "selections": [
                                        (v27 /*: any*/),
                                        (v28 /*: any*/),
                                        (v30 /*: any*/),
                                        (v3 /*: any*/)
                                    ]
                                },
                                (v32 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "mutation",
            "name": "CartTogglePCMembershipMutation",
            "id": null,
            "text": "mutation CartTogglePCMembershipMutation(\n  $input: CartTogglePCMembershipMutationInput!\n) {\n  cartTogglePCMembership(input: $input) {\n    cart {\n      id\n      autoShipEnabled\n      autoShipIntervalUnit\n      autoShipIntervalCount\n      c4cMode\n      enrollingAsPc\n      totalSavings\n      promoCodeSavings\n      pcPotentialSavings\n      viaQualifiedCartTotal\n      totalNumberOfItems\n      subTotalPriceOfItems\n      subTotalPriceOfItemsWithPromoCodes\n      promoCodeIsValid\n      eventId\n      entries {\n        edges {\n          node {\n            id\n            product {\n              id\n              name\n              price\n              productURLslug\n              images {\n                id\n                productCatalog\n              }\n              categoryFood\n              categoryMerch\n              categoryWine\n              company\n              priceSale\n              productId\n              inventorySKU\n              productPermissions {\n                oneCommerce {\n                  preferredCustomer {\n                    add\n                  }\n                }\n              }\n              promoCodeDiscount {\n                case4Cause {\n                  case12PriceUSD\n                  case6PriceUSD\n                  case6SKU\n                  case12SKU\n                  donationEligible\n                }\n              }\n            }\n            quantity\n          }\n        }\n      }\n      promoCodes {\n        code\n        promoDescription\n        thresholds {\n          discountAmount\n          discountAmountEach\n        }\n        id\n      }\n      promoCodeDiscountedItems {\n        id\n        nonDiscountedSkus {\n          edges {\n            node {\n              id\n              sku\n              discountAmount\n              productId\n              quantity\n              product {\n                id\n                productId\n                productURLslug\n                name\n                price\n                priceSale\n                productPermissions {\n                  oneCommerce {\n                    preferredCustomer {\n                      add\n                    }\n                  }\n                }\n                promoCodeDiscount {\n                  case4Cause {\n                    case6PriceUSD\n                  }\n                }\n                images {\n                  id\n                  productCatalog\n                  productFront\n                  productBack\n                }\n              }\n            }\n          }\n        }\n        discountedSkus {\n          edges {\n            node {\n              id\n              sku\n              discountAmount\n              productId\n              quantity\n              product {\n                id\n                productId\n                productURLslug\n                name\n                price\n                priceSale\n                productPermissions {\n                  oneCommerce {\n                    preferredCustomer {\n                      add\n                    }\n                  }\n                }\n                promoCodeDiscount {\n                  case4Cause {\n                    case6PriceUSD\n                  }\n                }\n                images {\n                  id\n                  productCatalog\n                  productFront\n                  productBack\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '6f95086977c817b0939c80ed424600d5';
export default node;
